import { render, staticRenderFns } from "./CatalogusItem.vue?vue&type=template&id=3217b7ac&scoped=true"
import script from "./CatalogusItem.vue?vue&type=script&lang=js"
export * from "./CatalogusItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3217b7ac",
  null
  
)

export default component.exports